/**
 * TBK automated preorder — syncs CTA, pricing, and category dispatch timelines.
 */
(function () {
  'use strict';

  var STR = (window.theme && window.theme.strings) || {};
  var PREORDER_LABEL = STR.preOrder || 'Pre-order Now';
  var ATC_LABEL = STR.addToCart || 'Add to cart';
  var SOLD_LABEL = STR.soldOut || 'Sold out';
  var DISPATCH_PROPERTY = STR.dispatchPropertyLabel || 'Estimated dispatch';

  var globalDispatchConfig = null;

  function parseJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function getGlobalDispatchConfig() {
    if (globalDispatchConfig) return globalDispatchConfig;
    var node = document.querySelector('[data-preorder-dispatch-config-global]');
    globalDispatchConfig = parseJson(node);
    return globalDispatchConfig;
  }

  function getDispatchConfig(root) {
    var local = parseJson(root && root.querySelector('[data-preorder-dispatch-config]'));
    if (local && local.categories) return local;
    return getGlobalDispatchConfig();
  }

  function getDispatchCopy(category, config) {
    var key = category || 'hand_tufted';
    var cfg = config && config.categories ? config.categories[key] : null;
    if (!cfg && config && config.categories) {
      cfg = config.categories.hand_tufted;
    }
    return (
      cfg || {
        timeline: '',
        message: '',
        short: '',
      }
    );
  }

  function parseConfig(root) {
    var node = root && root.querySelector('[data-preorder-config]');
    if (!node) return { enable: true, lowStockThreshold: 5, dispatchCategory: 'hand_tufted' };
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return { enable: true, lowStockThreshold: 5, dispatchCategory: 'hand_tufted' };
    }
  }

  function getInventoryMap(scope) {
    if (!scope) return null;
    var root = scope.closest ? scope.closest('[data-preorder-system]') || scope.closest('product-form') || scope : scope;
    var node = root && root.querySelector('[data-product-inventory-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function enrichVariantFromInventoryMap(variant, scope) {
    if (!variant || !variant.id) return variant;
    var map = getInventoryMap(scope);
    if (!map || !map[variant.id]) return variant;
    var row = map[variant.id];
    return {
      inventory_management: row.inventory_management != null ? row.inventory_management : variant.inventory_management,
      inventory_quantity: row.inventory_quantity != null ? row.inventory_quantity : variant.inventory_quantity,
      inventory_policy: row.inventory_policy != null ? row.inventory_policy : variant.inventory_policy,
      available: row.available != null ? row.available : variant.available,
      compare_at_price: variant.compare_at_price,
      price: variant.price,
      id: variant.id,
    };
  }

  function getVariantInventoryQuantity(variant, scope) {
    if (!variant) return null;
    var enriched = enrichVariantFromInventoryMap(variant, scope);
    var raw = enriched.inventory_quantity;
    if (typeof raw === 'number' && !isNaN(raw)) return raw;
    if (typeof raw === 'string' && raw !== '' && !isNaN(Number(raw))) {
      return parseInt(raw, 10);
    }

    var remainingRoot = scope && scope.closest ? scope.closest('[data-section-id]') || scope : scope;
    var remainingNode = remainingRoot && remainingRoot.querySelector('[data-product-remaining-json]');
    if (remainingNode && variant.id) {
      try {
        var remaining = JSON.parse(remainingNode.textContent);
        var val = remaining[variant.id];
        if (val !== null && val !== undefined && val !== 'null' && val !== '') {
          var parsed = parseInt(val, 10);
          if (!isNaN(parsed)) return parsed;
        }
      } catch (e) {
        /* ignore */
      }
    }
    return null;
  }

  function variantState(variant, config, scope) {
    if (!variant || config.enable === false) {
      return variant && variant.available ? 'in_stock' : 'unavailable';
    }
    var v = enrichVariantFromInventoryMap(variant, scope);
    if (v.inventory_management === 'shopify') {
      var qty = getVariantInventoryQuantity(v, scope);
      if (qty === null) {
        return v.available ? 'in_stock' : v.inventory_policy === 'continue' ? 'preorder' : 'sold_out';
      }
      if (qty > 0) {
        if (qty <= (config.lowStockThreshold || 5)) return 'low_stock';
        return 'in_stock';
      }
      return v.inventory_policy === 'continue' || v.available ? 'preorder' : 'sold_out';
    }
    if (!v.available) {
      return v.inventory_policy === 'continue' ? 'preorder' : 'sold_out';
    }
    return 'in_stock';
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function getDisplayPricing(variant, config, scope) {
    var state = variantState(variant, config, scope);
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (onSale && state === 'preorder') {
      return {
        mode: 'preorder_original',
        price: variant.compare_at_price,
        comparePrice: null,
        onSale: false,
      };
    }
    if (onSale) {
      return {
        mode: 'sale',
        price: variant.price,
        comparePrice: variant.compare_at_price,
        onSale: true,
      };
    }
    return {
      mode: 'regular',
      price: variant.price,
      comparePrice: null,
      onSale: false,
    };
  }

  function canPurchase(variant, state) {
    if (!variant) return false;
    if (state === 'preorder') {
      return !!(variant.available || variant.inventory_policy === 'continue');
    }
    return !!variant.available;
  }

  function buttonLabel(state, purchase) {
    if (state === 'preorder') return PREORDER_LABEL;
    if (!purchase && state === 'sold_out') return SOLD_LABEL;
    if (!purchase) return SOLD_LABEL;
    return ATC_LABEL;
  }

  function ensurePreorderInputs(form, state, dispatchShort) {
    if (!form) return;
    var saleType = form.querySelector('[data-preorder-sale-type]');
    if (state === 'preorder') {
      if (!saleType) {
        saleType = document.createElement('input');
        saleType.type = 'hidden';
        saleType.setAttribute('data-preorder-sale-type', '');
        saleType.name = 'properties[Sale type]';
        saleType.value = PREORDER_LABEL;
        form.appendChild(saleType);
      }
      ['_preorder', 'preorder'].forEach(function (key) {
        if (!form.querySelector('input[name="properties[' + key + ']"]')) {
          var el = document.createElement('input');
          el.type = 'hidden';
          el.name = 'properties[' + key + ']';
          el.value = 'true';
          form.appendChild(el);
        }
      });
      if (dispatchShort) {
        var dispatchInput = form.querySelector('[data-preorder-dispatch-property]');
        if (!dispatchInput) {
          dispatchInput = document.createElement('input');
          dispatchInput.type = 'hidden';
          dispatchInput.setAttribute('data-preorder-dispatch-property', '');
          dispatchInput.name = 'properties[' + DISPATCH_PROPERTY + ']';
          form.appendChild(dispatchInput);
        }
        dispatchInput.value = dispatchShort;
      }
    } else {
      if (saleType) saleType.remove();
      form.querySelectorAll('input[name="properties[_preorder]"], input[name="properties[preorder]"]').forEach(function (n) {
        n.remove();
      });
      var dispatchRemove = form.querySelector('[data-preorder-dispatch-property]');
      if (dispatchRemove) dispatchRemove.remove();
    }
  }

  function applyDispatchUI(scope, category, state, config) {
    if (!scope) return;
    var dispatchConfig = config || getGlobalDispatchConfig();
    var copy = getDispatchCopy(category, dispatchConfig);
    var isPreorder = state === 'preorder';

    scope.querySelectorAll('[data-preorder-dispatch-timeline]').forEach(function (el) {
      if (copy.timeline) el.textContent = copy.timeline;
    });

    scope.querySelectorAll('[data-preorder-dispatch-text]').forEach(function (el) {
      if (copy.message) el.textContent = copy.message;
    });

    scope.querySelectorAll('[data-preorder-dispatch-short]').forEach(function (el) {
      if (copy.short) el.textContent = copy.short;
    });

    scope.querySelectorAll('[data-preorder-grid-dispatch]').forEach(function (el) {
      el.hidden = !isPreorder;
      if (category) el.setAttribute('data-dispatch-category', category);
    });

    scope.querySelectorAll('[data-preorder-banner][data-dispatch-category]').forEach(function (el) {
      if (category) el.setAttribute('data-dispatch-category', category);
    });
  }

  function applyButton(btn, variant, config, dispatchShort) {
    var scope = btn.closest('product-form') || btn.closest('[data-preorder-system]') || btn.closest('product-grid-item');
    var state = variantState(variant, config, scope);
    var purchase = canPurchase(variant, state);
    var label = buttonLabel(state, purchase);

    btn.disabled = !purchase;
    btn.setAttribute('data-variant-state', state);
    btn.classList.toggle('btn--preorder', state === 'preorder');
    btn.classList.toggle('sold-out', !purchase && state !== 'preorder');

    var textEl = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('.btn-state-ready');
    if (textEl) textEl.textContent = label;

    var form = btn.closest('form');
    if (form) ensurePreorderInputs(form, state, dispatchShort);
  }

  function updateProductPrices(root, variant, config) {
    var pricing = getDisplayPricing(variant, config, root);
    var section = root.closest('[data-section-id]') || root;

    section.querySelectorAll('[data-price-wrapper]').forEach(function (wrap) {
      var productPriceEl = wrap.querySelector('[data-product-price]');
      var compareEl = wrap.querySelector('[data-compare-price], [data-compare-text], .product__price--compare');
      var saveBadge = wrap.querySelector('[data-preorder-save-badge]');

      if (productPriceEl) {
        productPriceEl.innerHTML = formatMoney(pricing.price);
        productPriceEl.classList.toggle('product__price--sale', pricing.onSale);
        productPriceEl.classList.toggle('preorder-price--original', pricing.mode === 'preorder_original');
      }

      if (compareEl) {
        var showCompare = pricing.onSale && pricing.comparePrice;
        compareEl.classList.toggle('hide', !showCompare);
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.innerHTML = formatMoney(pricing.comparePrice);
      }

      if (saveBadge) {
        saveBadge.classList.toggle('hide', !pricing.onSale);
        saveBadge.hidden = !pricing.onSale;
      }
    });

    section.querySelectorAll('[data-button-price]').forEach(function (el) {
      el.innerHTML = formatMoney(pricing.price);
    });
  }

  function updateGridPrice(card, variantData, config) {
    var pricing = getDisplayPricing(variantData, config, card);
    var priceWrap = card.querySelector('[data-preorder-grid-price]');
    if (!priceWrap) return;

    var mainEl = priceWrap.querySelector('[data-grid-price-main]');
    var compareEl = priceWrap.querySelector('[data-grid-price-compare]');

    if (mainEl) {
      var fromPrefix = mainEl.getAttribute('data-price-from-prefix') || '';
      mainEl.innerHTML = fromPrefix + formatMoney(pricing.price);
      mainEl.classList.toggle('on-sale', pricing.onSale);
    }

    if (compareEl) {
      compareEl.classList.toggle('hide', !pricing.onSale);
      compareEl.hidden = !pricing.onSale;
      if (pricing.onSale && pricing.comparePrice) {
        compareEl.innerHTML = formatMoney(pricing.comparePrice);
      }
    }

    priceWrap.setAttribute('data-price-mode', pricing.mode);

    var badge = card.querySelector('.product__badge--sale');
    if (badge) badge.classList.toggle('hide', !pricing.onSale);
  }

  function updateProductForm(root, variant) {
    if (!root || !variant) return;
    var enriched = enrichVariantFromInventoryMap(variant, root);
    var config = parseConfig(root);
    var dispatchConfig = getDispatchConfig(root);
    var category = config.dispatchCategory || 'hand_tufted';
    var dispatchCopy = getDispatchCopy(category, dispatchConfig);
    var state = variantState(enriched, config, root);
    var purchase = canPurchase(enriched, state);
    var wrapper = root.querySelector('[data-buttons-wrapper]');
    var form = root.querySelector('form[action*="/cart/add"]');

    if (wrapper) wrapper.setAttribute('data-variant-state', state);

    root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      applyButton(btn, enriched, config, dispatchCopy.short);
    });

    if (form) ensurePreorderInputs(form, state, dispatchCopy.short);

    updateProductPrices(root, enriched, config);
    applyDispatchUI(root, category, state, dispatchConfig);

    root.querySelectorAll('[data-preorder-banner]').forEach(function (el) {
      var show = state === 'preorder' || state === 'low_stock';
      el.hidden = !show;
      el.classList.toggle('hide', !show);
      el.classList.toggle('preorder-banner--low', state === 'low_stock');
      var preorderContent = el.querySelector('[data-preorder-content]');
      var lowStockContent = el.querySelector('[data-low-stock-content]');
      if (preorderContent) preorderContent.hidden = state !== 'preorder';
      if (lowStockContent) lowStockContent.hidden = state !== 'low_stock';
    });

    var buyNow = root.querySelector('[data-buy-now]');
    if (buyNow) buyNow.classList.toggle('hide', state === 'preorder' || !purchase);

    var note = root.querySelector('[data-preorder-policy-note]');
    if (note) note.hidden = !(state === 'preorder' && !purchase);
  }

  function getVariantFromProductJson(root, variantId) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return null;
    try {
      var product = JSON.parse(json.textContent);
      return product.variants.find(function (v) {
        return v.id === variantId;
      });
    } catch (e) {
      return null;
    }
  }

  function parseCardPreorderData(card) {
    var json = card.querySelector('[data-preorder-product]');
    if (!json) return null;
    try {
      var parsed = JSON.parse(json.textContent);
      var category = parsed.dispatchCategory || json.getAttribute('data-dispatch-category') || 'hand_tufted';
      var map = parsed.variants || parsed;
      return { map: map, category: category };
    } catch (e) {
      return null;
    }
  }

  function onVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var target = event.target;
    var formRoot = target.closest('[data-preorder-system]') || target.closest('product-form');
    if (formRoot) {
      requestAnimationFrame(function () {
        updateProductForm(formRoot, variant);
      });
    } else {
      requestAnimationFrame(function () {
        var section = target.closest('[data-section-id]');
        if (section) {
          var config = parseConfig(section);
          updateProductPrices(section, variant, config);
        }
      });
    }
  }

  function initCard(card) {
    if (card.getAttribute('data-preorder-card-init') === 'true') return;
    card.setAttribute('data-preorder-card-init', 'true');

    var cardData = parseCardPreorderData(card);
    if (!cardData) return;

    var map = cardData.map;
    var category = cardData.category;
    var config = { enable: true, lowStockThreshold: 5 };
    var dispatchConfig = getGlobalDispatchConfig();

    function syncVariant(variantData) {
      if (!variantData) return;
      var state = variantState(variantData, config, card);
      card.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        applyButton(btn, variantData, config, getDispatchCopy(category, dispatchConfig).short);
      });
      updateGridPrice(card, variantData, config);
      applyDispatchUI(card, category, state, dispatchConfig);
      card.querySelectorAll('.product-grid-item__content').forEach(function (content) {
        content.classList.toggle('preorder-card', state === 'preorder');
      });
    }

    var activeVariantEl = card.querySelector('[data-grid-item-variant]');
    if (activeVariantEl) {
      var vid = activeVariantEl.getAttribute('data-grid-item-variant');
      if (vid && map[vid]) syncVariant(map[vid]);
    }

    card.querySelectorAll('[data-swatch] a, [data-grid-item-variant]').forEach(function (node) {
      node.addEventListener(
        'click',
        function () {
          var id = node.getAttribute('data-grid-item-variant');
          if (!id) {
            var parent = node.closest('[data-grid-item-variant]');
            if (parent) id = parent.getAttribute('data-grid-item-variant');
          }
          if (!id || !map[id]) return;
          setTimeout(function () {
            syncVariant(map[id]);
          }, 50);
        },
        true
      );
    });

    card.querySelectorAll('form[data-preorder-card-form]').forEach(function (form) {
      form.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      form.addEventListener('submit', function (e) {
        e.stopPropagation();
      });
    });
  }

  function initAllCards() {
    document.querySelectorAll('product-grid-item').forEach(initCard);
  }

  document.addEventListener('theme:variant:change', onVariantChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCards);
  } else {
    initAllCards();
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('product-grid-item')) initCard(node);
          if (node.querySelectorAll) node.querySelectorAll('product-grid-item').forEach(initCard);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.querySelectorAll('[data-preorder-system] product-form, product-form[data-preorder-system]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    try {
      var product = JSON.parse(json.textContent);
      var idInput = root.querySelector('[name="id"]');
      if (idInput && product.variants) {
        var current = product.variants.find(function (v) {
          return String(v.id) === String(idInput.value);
        });
        if (current) updateProductForm(root, current);
      }
    } catch (e) {
      /* ignore */
    }
  });
})();
